import { render, staticRenderFns } from "./PanelInfoBox.vue?vue&type=template&id=63adabee&scoped=true&"
import script from "./PanelInfoBox.vue?vue&type=script&lang=js&"
export * from "./PanelInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./PanelInfoBox.vue?vue&type=style&index=0&id=63adabee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63adabee",
  null
  
)

export default component.exports